import { Box, Button, Flex, Text } from "@chakra-ui/react"
import { FileArrowDown } from "@phosphor-icons/react"

const File = () => {
	return (
		<Box w="full">
			<Flex w="full">
				<Flex justifyContent="center" alignItems="center" mr="6">
					<Button colorScheme="green" leftIcon={<FileArrowDown size="22" weight="fill"/>}> Baixar</Button>
				</Flex>
				<Box>
					<Text fontSize="lg">Nome do arquivo</Text>
					<Text fontSize="sm" mb="2">Adicionado em: 01/01/2024 10:00:00</Text>
				</Box>
			</Flex>
		</Box>
	)
}

export default File
